import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValueDefault } from '@/main/models/common';
import { CountryPublicResponse } from '@/main/models/response';

export abstract class ICountryApi {
  abstract getDomain(
    idUser: string | null
  ): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;
  abstract getPublicDomain(): Promise<
    AxiosResponse<Result<CountryPublicResponse[]>>
  >;
}

